
import cogoToast from "cogo-toast";
import { CustomToast } from "../components/CustomToast/CustomToast";

let currentToast = null;

let lastToastKey = "";
let lastToastTime = 0;

const DUPLICATE_GAP = 2000;

const showToast = (type, message, heading = "") => {

    const now = Date.now();
    const toastKey = `${type}|${heading}|${message}`;

    // Prevent duplicate spam
    if (
        lastToastKey === toastKey &&
        now - lastToastTime < DUPLICATE_GAP
    ) {
        return currentToast;
    }

    lastToastKey = toastKey;
    lastToastTime = now;

    // Remove existing toast
    if (currentToast?.hide) {
        currentToast.hide();
    }

    // Show latest toast
    currentToast = cogoToast[type](
        <CustomToast
            type={type}
            message={message}
            heading={heading}
        />,
        {
            position: "top-center",
            hideAfter: 2,
        }
    );

    return currentToast;
};

const Toast = {
    success: (message, heading = "Success") =>
        showToast("success", message, heading),

    error: (message, heading = "Error") =>
        showToast("error", message, heading),

    warn: (message, heading = "Warning") =>
        showToast("warn", message, heading),

    info: (message, heading = "Info") =>
        showToast("info", message, heading),
    
    loading: (message, heading = "Loading") =>
        showToast("loading", message, heading),
};

export default Toast;
